// Section for import npm components -----------------------------------------------------------------------------------
import React from 'react';

// Material UI ( mui )  components
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';

// Section for import custom types -------------------------------------------------------------------------------------
import Regions from '@config/data/regionItems.json';
import PrefecturesData from '@/types/components/MansionNavigation/PrefecturesData';

interface PrefecturesListProps {
  prefecturesData: PrefecturesData;
  postfixLinkText: string;
}

export default function PrefecturesList({ prefecturesData, postfixLinkText }: PrefecturesListProps): React.JSX.Element {
  return (
    <Box className="grid grid-rows-4 grid-flow-col gap-x-4 xl:gap-x-20 lg:gap-x-10 gap-y-7 mr-3">
      {Regions.map((region) => (
        <List key={region.sort_id} className="p-0">
          <ListItem className="flex flex-col items-start md:p-0">
            <Box className="mb-2">
              <Typography className="text-sm font-bold">{region.region_name}</Typography>
            </Box>
            <Box className="flex flex-wrap gap-x-5 gap-y-3 pl-5">
              {prefecturesData
                .filter((prefectureData) => prefectureData.region_id === region.region_id)
                .map((prefecture) => (
                  <Box key={`box-${region.sort_id}-${prefecture.id}`} className="flex items-center">
                    <Link
                      href={`/karte/${prefecture.pref_code_name}${postfixLinkText}`}
                      className="h-[18px] text-sm text-black rf-hover-text border-b-[1px] border-rf-black"
                      underline="none"
                    >
                      {prefecture.pref_name}
                    </Link>
                  </Box>
                ))}
            </Box>
          </ListItem>
        </List>
      ))}
    </Box>
  );
}
